export const APP_ID = 14;
// DOCS: Updated 2.2.5 to 6.0.1 - Google spot journey
export const APP_VERSION = '6.0.1';

// DOCS: UPI options is not getting exising vention
export const APP_ID_REPAY = 14;
export const APP_VERSION_REPAY = '6.0.1';
